import { Component } from '@angular/core';

@Component({
  selector: 'app-iifl-redirection',
  templateUrl: './iifl-redirection.component.html',
  styleUrls: ['./iifl-redirection.component.scss']
})
export class IiflRedirectionComponent {

  ngOnInit() {
    let w = window.innerWidth
      if (w <= 767) {
        window.location.href ="/mobilesession";
      } else {
        // window.open("https://aaa.indiainfoline.com/login","_self");
      }
  }
}
